export default "__VITE_ASSET__DCX3Hoev__"